<template>
    <div class="mb-4">
        <div class="w-full py-4 border-b-2 border-primary mb-4">
            <div class="grid grid-flow-col gap-4 content-center">
                <div>
                    <h2 class="font-semibold text-2xl block"> {{ group.name }} </h2>
                </div>
                <div class="text-right">
                    <span class="inline-flex h-full items-center">
                         <FontAwesomeIcon :icon="['fa-solid', 'fa-sun-bright']"></FontAwesomeIcon>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="group.badges.length" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <div class="!block w-full md:w-auto" v-for="(badge, index) in group.badges.slice(0, 1)">
                <WinnersCard
                    v-for="(product in badge.products.slice(0,1)"
                    :product="product"
                    :reviewLink="reviewsLink"
                    :badge="badge"
                />
            </div>
            <div class="md:col-span-2">
                <p class="font-bold text-center border-b-2 border-grey-200 pb-4 mb-4">Other notable mentions</p>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div class="lg:flex lg:flex-wrap" v-for="(badge, index) in filteredBadges">
                        <TyreCard
                            class="lg:w-full xl:w-auto"
                            v-for="(product) in badge.products"
                            :product="product"
                            :badge="badge"
                        >
                            <template v-slot:header>
                                <div class="h-14 mb-3 flex items-end">
                                    <strong class="block text-center">{{ badge.name }}</strong>
                                </div>
                            </template>
                            <template v-if="reviewsLink" v-slot:footer>
                                <AppButton class="bg-red text-white mt-2 whitespace-nowrap" :href="reviewsLink">
                                    Watch Review
                                </AppButton>
                            </template>
                        </TyreCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import WinnersCard from "@/Components/Awards/WinnersCard";
import AppVideo from "@/Components/AppVideo";
import AppButton from "@/Components/AppButton";
import AppCard from "@/Components/AppCard";
export default {
    name: "AwardGroup",
    props:
    {
        group: Object
    },
    components:
    {
        AppButton,
        AppCard,
        AppVideo,
        WinnersCard,
        FontAwesomeIcon,
        TyreCard
    },
    computed:
    {
        reviewsLink()
        {
            const post = this.group.post ?? null;

            if(post)
            {
                return route('steves-reviews.show', post.slug);
            }
        },
        filteredBadges()
        {
            const badges = this.group.badges.slice(1);

            const results = [];

            for(let index = 0; index < badges.length; index++)
            {
                if (Object.keys(badges[index]['products']).length !== 0)
                {
                    results.push(badges[index]);
                }
            }

            return results;
        }
    },
    methods:
    {
        getIcon(season)
        {
            var seasons = ['Summer', 'Summer Conditions', 'Winter'];
            var icons = ['fa-sun-bright', 'fa-cloud-sun-rain', 'fa-snowflake'];

            var array_key = this.arraySearch(seasons, season);

            return icons[array_key];
        },
        arraySearch(arr, val)
        {
            var index;
            for (var i = 0; i < arr.length; i++)
            {
                // use '===' if you strictly want to find the same type
                if (arr[i] == val)
                {
                    if (index == undefined) index = i;
                    // return false if duplicate is found
                    else return false;
                }
            }

            // return false if no element found, or index of the element
            return index == undefined ? false : index;
        }
    }
}
</script>

<style scoped>

</style>
